export * from './merge-storage.component'